import React from "react";
import "./PT.css";

// Import images
import Img1 from "../../../Gallery/ServicesImages/PT/img1.png";
import Img2 from "../../../Gallery/ServicesImages/PT/img2.jpg";
import Img3 from "../../../Gallery/ServicesImages/PT/img3.avif";


function PT() {
  const products = [
    {
      title: "Pallet Slip Sheets",
      img: Img1,
      specs: [
        "Material: PP",
        "Color: Black",
        "Size: 1120 x 1420 mm"
      ]
    },
    {
      title: "Industrial Packaging Tray",
      img: Img2,
      specs: [
        "Material: HDPE / PP",
        "Color: Customizable",
        "Custom sizes available"
      ]
    },
    {
      title: "Fabricated Acrylic Boxes",
      img: Img3,
      specs: [
        "Material: Transparent / Customized color options",
        "Product Type: Other, Acrylic Box",
        "Size:Custom Size Available"
      ]
    },
  ];

  return (
    <div className="pt-wrapper">
      <h1 className="pt-title">Packaging Trays</h1>

      <div className="pt-grid">
        {products.map((p, i) => (
          <div className="pt-card" key={i}>
            <img src={p.img} alt={p.title} className="pt-img" />
            <h3 className="pt-card-title">{p.title}</h3>

            <ul className="pt-spec-list">
              {p.specs.map((s, index) => (
                <li key={index}>{s}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PT;
